import { getEnvironmentVariable } from '../../core/helpers'

const getAutoEatMenuUrl = menuId =>
  `${getEnvironmentVariable('REACT_APP_AUTOEAT_WEB_URL')}/menus/${menuId}`

export default getAutoEatMenuUrl
